
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgRocket = props => /*#__PURE__*/React.createElement("svg", _extends({
  height: 28,
  width: 30,
  fill: "var(--theme-primary, #810ea9)",
  viewBox: "0 0 32 32",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.553 27.602c-.628 1.306-1.025 2.177-4.522 2.304.1-3.374.744-3.736 2.031-4.378.54-.27 1.213-.605 1.941-1.164l-1.218-1.555c-.575.442-1.104.674-1.615.928C1.025 24.807.014 25.86.014 30.882l.017 1.022.983-.022c5.301 0 6.292-1.198 7.285-3.26.217-.452.338-.758.705-1.367l-1.483-1.347c-.444.607-.722 1.183-.968 1.692zM22.03 5.896c-2.212 0-4.011 1.799-4.011 4.01s1.8 4.011 4.011 4.011 4.011-1.8 4.011-4.011-1.8-4.011-4.011-4.011zm0 6.013c-1.104 0-2.003-.899-2.003-2.002s.898-2.002 2.003-2.002 2.003.899 2.003 2.002a2.004 2.004 0 0 1-2.003 2.002M31.993.916a1 1 0 0 0-.925-.936s-5.596-.408-10.98 1.603c-1.967.735-3.586 1.898-5.097 3.661-1.26 1.47-2.512 4.126-3.617 6.332-.427.851-.835 1.666-1.181 2.288H4.63c-.286 0-.558.123-.748.336L.216 18.173a1 1 0 0 0 .525 1.639l5.967 1.364c.407.502 1.084 1.253 2.168 2.456l2.261 2.506 1.217 5.148a.996.996 0 0 0 1.623.528l3.705-3.686a1 1 0 0 0 .349-.759v-5.16c.498-.309 1.381-.786 2.212-1.251 2.264-1.265 5.645-2.841 7.046-4.087 1.974-1.754 2.692-3.04 3.398-4.941C32.365 7.409 32.009 1.179 31.992.916zm-3.18 10.317c-.616 1.659-1.174 2.651-2.852 4.142-1.239 1.101-4.629 2.682-6.694 3.837-1.541.861-2.464 1.364-2.869 1.695a1 1 0 0 0-.368.774v5.227l-2.11 2.319-.899-3.8a1 1 0 0 0-.231-.439 1904 1904 0 0 1-4.83-5.364 1 1 0 0 0-.549-.339L2.83 18.237l2.247-2.375h5.689a1 1 0 0 0 .852-.476c.44-.716.95-1.736 1.542-2.915 1.002-1.998 2.248-4.642 3.348-5.926 1.3-1.516 2.619-2.469 4.278-3.089 3.691-1.379 7.499-1.524 9.24-1.511.032 1.844-.037 6.119-1.214 9.289z"
})));

      const __svgRaw = "<svg height=\"28\" width=\"30\" fill=\"var(--theme-primary, #810ea9)\" viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><g stroke-width=\"0\"/><g stroke-linecap=\"round\" stroke-linejoin=\"round\"/><path d=\"M6.553 27.602c-.628 1.306-1.025 2.177-4.522 2.304.1-3.374.744-3.736 2.031-4.378.54-.27 1.213-.605 1.941-1.164l-1.218-1.555c-.575.442-1.104.674-1.615.928C1.025 24.807.014 25.86.014 30.882l.017 1.022.983-.022c5.301 0 6.292-1.198 7.285-3.26.217-.452.338-.758.705-1.367l-1.483-1.347c-.444.607-.722 1.183-.968 1.692zM22.03 5.896c-2.212 0-4.011 1.799-4.011 4.01s1.8 4.011 4.011 4.011 4.011-1.8 4.011-4.011-1.8-4.011-4.011-4.011zm0 6.013c-1.104 0-2.003-.899-2.003-2.002s.898-2.002 2.003-2.002 2.003.899 2.003 2.002a2.004 2.004 0 0 1-2.003 2.002M31.993.916a1 1 0 0 0-.925-.936s-5.596-.408-10.98 1.603c-1.967.735-3.586 1.898-5.097 3.661-1.26 1.47-2.512 4.126-3.617 6.332-.427.851-.835 1.666-1.181 2.288H4.63c-.286 0-.558.123-.748.336L.216 18.173a1 1 0 0 0 .525 1.639l5.967 1.364c.407.502 1.084 1.253 2.168 2.456l2.261 2.506 1.217 5.148a.996.996 0 0 0 1.623.528l3.705-3.686a1 1 0 0 0 .349-.759v-5.16c.498-.309 1.381-.786 2.212-1.251 2.264-1.265 5.645-2.841 7.046-4.087 1.974-1.754 2.692-3.04 3.398-4.941C32.365 7.409 32.009 1.179 31.992.916zm-3.18 10.317c-.616 1.659-1.174 2.651-2.852 4.142-1.239 1.101-4.629 2.682-6.694 3.837-1.541.861-2.464 1.364-2.869 1.695a1 1 0 0 0-.368.774v5.227l-2.11 2.319-.899-3.8a1 1 0 0 0-.231-.439 1904 1904 0 0 1-4.83-5.364 1 1 0 0 0-.549-.339L2.83 18.237l2.247-2.375h5.689a1 1 0 0 0 .852-.476c.44-.716.95-1.736 1.542-2.915 1.002-1.998 2.248-4.642 3.348-5.926 1.3-1.516 2.619-2.469 4.278-3.089 3.691-1.379 7.499-1.524 9.24-1.511.032 1.844-.037 6.119-1.214 9.289z\"/>\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/rocket.650008bbd5e59dbfdf19f518dd50f647.svg"),
        {
          React: SvgRocket,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      